import { persist } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';

const defaultConsents = {
  terms: false,
  marketing: false,
};

export interface LoginConsents {
  terms: boolean;
  marketing: boolean;
}

export type ConsentType = keyof LoginConsents;

export interface LoginConsentStore {
  consents: LoginConsents;
  setConsent: (name: ConsentType, value: boolean) => void;
  setMultipleConsents: (consents: Partial<LoginConsents>) => void;
  resetConsents: () => void;
  acceptAllConsents: () => void;
  getConsent: (name: ConsentType) => boolean;
}

export const useLoginConsentStore = create(
  persist<LoginConsentStore>(
    (set, get) => ({
      consents: defaultConsents,
      setConsent: (name, value) =>
        set(() => ({
          consents: {
            ...get().consents,
            [name]: value,
          },
        })),
      setMultipleConsents: (consents) =>
        set(() => {
          return {
            consents: {
              ...get().consents,
              ...consents,
            },
          };
        }),
      resetConsents: () =>
        set(() => ({
          consents: defaultConsents,
        })),
      acceptAllConsents: () =>
        set(() => {
          const isAllAccepted = Object.values(get().consents).every(Boolean);
          const newValue = !isAllAccepted;

          return {
            consents: {
              marketing: newValue,
              terms: newValue,
            },
          };
        }),
      getConsent: (name) => get().consents[name],
    }),
    {
      name: 'login-consents-store', // name of the item in the storage (must be unique)
    },
  ),
);
